import React from 'react';
import { contactItems, salon, whatsappHref } from '../data/content';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { ArrowIcon, InstagramIcon, MailIcon, MobileIcon, PhoneIcon, PinIcon } from './icons/GoldIcons';
const iconMap = {
  phone: PhoneIcon,
  mobile: MobileIcon,
  pin: PinIcon,
  instagram: InstagramIcon,
  mail: MailIcon
};
export function Contact() {
  const {
    t
  } = useLanguage();
  const waHref = whatsappHref(t.whatsappMessage);
  return <section id="contacto" className="w-full bg-ink-900 py-24 sm:py-32" data-id="element-30" data-mp="3oxfpujg8bd7b">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-31" data-mp="3k4mj5q179usl">
        <SectionHeading eyebrow={t.contact.eyebrow} title={t.contact.title} intro={t.contact.intro} data-id="element-32" data-mp="3k330xtvzh9o6" />

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-gold-deep/30 bg-gold-deep/25 sm:grid-cols-2" data-id="element-33" data-mp="3f4iagm6ja4cx">
          {contactItems.map(item => {
          const Icon = iconMap[item.icon];
          const href = item.id === 'cel' ? waHref : item.href;
          const content = <>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold-deep/40 text-gold-soft transition-colors duration-200 group-hover:border-gold-soft group-hover:text-gold-ivory" data-id="element-34" data-mp="3oueeqenjcrn5">
                  <Icon className="h-5 w-5" data-id="element-35" data-mp="3f3t9w9h9qqvs" />
                </span>
                <span className="min-w-0" data-id="element-36" data-mp="315d4qmz218fr">
                  <span className="block text-[10px] uppercase tracking-[0.24em] text-neutral-500" data-id="element-37" data-mp="313igayokqy6x">
                    {t.contact.labels[item.id]}
                  </span>
                  <span className="mt-1 block break-words text-[15px] text-neutral-100" data-id="element-38" data-mp="2s56tz8uqqmka">
                    {item.value}
                  </span>
                </span>
              </>;
          return <div key={item.id} className="bg-ink-900" data-id="element-39" data-mp="qcio0rqppl0t">
                {href ? <a href={href} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noreferrer' : undefined} className="group flex h-full items-center gap-5 px-7 py-6 transition-colors duration-200 hover:bg-gold-deep/10" data-id="element-40" data-mp="qb7jgppg098n">
                    {content}
                  </a> : <div className="flex h-full items-center gap-5 px-7 py-6" data-id="element-41" data-mp="1yeu1kby06xqv">{content}</div>}
              </div>;
        })}
        </div>

        <div className="mt-12 flex flex-col items-center gap-4 sm:flex-row sm:justify-center" data-id="element-42" data-mp="1pccdrt2p9x1r">
          <a href={waHref} target="_blank" rel="noreferrer" className="btn-gold-shine inline-flex w-full items-center justify-center gap-3 whitespace-nowrap rounded-full px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.14em] sm:w-auto" data-id="element-43" data-mp="2m2ld3dbpz6r3">
            {t.ctaShort}
            <ArrowIcon className="h-4 w-4" strokeWidth={1.8} data-id="element-44" data-mp="2d7f3025f22ir" />
          </a>
          <a href={salon.phoneHref} className="inline-flex w-full items-center justify-center gap-3 rounded-full border border-gold-deep/50 px-9 py-4 text-[13px] font-semibold uppercase tracking-[0.22em] text-gold-soft transition-colors duration-200 hover:border-gold-soft hover:text-gold-ivory sm:w-auto" data-id="element-45" data-mp="28aewxr8kgzrn">
            <PhoneIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-46" data-mp="38cbpuvgf85fo" />
            {t.contact.callNow}
          </a>
          <a href={salon.instagramHref} target="_blank" rel="noreferrer" className="inline-flex w-full items-center justify-center gap-3 rounded-full border border-gold-deep/50 px-9 py-4 text-[13px] font-semibold uppercase tracking-[0.22em] text-gold-soft transition-colors duration-200 hover:border-gold-soft hover:text-gold-ivory sm:w-auto" data-id="element-47" data-mp="3dbobxdzgx8h7">
            <InstagramIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-48" data-mp="2a1bi6nzn68" />
            {t.contact.writeUs}
          </a>
        </div>
      </div>
    </section>;
}